
import { computed, defineComponent, onMounted, ref } from "vue";
import { useStore } from "../store";
import BaseFeedHeader from "../components/BaseFeedHeader.vue";
import Room from "../interfaces/Room/Room.interface";
import RoomCard from "../components/RoomCard.vue";

export default defineComponent({
  name: "RoomFeed",
  components: { RoomCard, BaseFeedHeader },
  setup() {
    const store = useStore();
    const searchInput = ref("");
    const changeInput = (input: string) => {
      searchInput.value = input;
    };
    const rooms = ref([] as Room[]);

    onMounted(async () => {
      await reload(true);
    });

    /**
     * Reloads all rooms
     * @editSnackbar defines if the snackbar should be changed when loading the rooms. When a room has been deleted the user should receive feedback from the delete action that the user has been deleted, and therefore editSnackbar has to be false to not override the previous feedback.
     */
    const reload = async (editSnackBar: boolean) => {
      const response = await store.dispatch("getRooms", editSnackBar);
      if (response === null) return;
      rooms.value = response;
    };

    const availableRooms = computed(() =>
      rooms.value.filter(
        (room) =>
          room.roomCode
            .toLowerCase()
            .startsWith(searchInput.value.toLowerCase()) ||
          sectionContainsSearch(room)
      )
    );

    const sectionContainsSearch = (room: Room): boolean => {
      for (const section of room.sections)
        if (
          section.sectionName
            .toLowerCase()
            .startsWith(searchInput.value.toLowerCase())
        )
          return true;
      return false;
    };

    const isAdmin = computed(() => store.getters.getUser.isAdmin);

    return {
      searchInput,
      changeInput,
      isAdmin,
      rooms,
      reload,
      availableRooms,
    };
  },
});
